<template>
    <el-select
        :value="value"
        :disabled="disabled"
        :placeholder="placeholder"
        filterable
        default-first-option
        :style="selectStyle"
        @input="$emit('input', $event)"
    >
        <el-option
            v-for="location in locationsPrepared"
            :key="location.id"
            :value="location.id"
            :label="location.title"
        />
    </el-select>
</template>

<script>
import _ from 'lodash';
import { Event } from '@/api';

export default {
    name: 'EventLocationSelect',

    props: {
        value: {
            type: String,
            default: null
        },

        eventId: {
            type: String,
            default: null
        },

        placeholder: {
            type: String,
            default: 'Укажите место проведения'
        },

        width: {
            type: String,
            default: '100%'
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            locations: []
        };
    },

    computed: {
        selectStyle() {
            return {
                width: this.width
            };
        },

        locationsPrepared() {
            return this.locations.map(location => ({
                id: _.get(location, 'id'),
                title: _.get(location, 'attributes.title')
            }));
        }
    },

    watch: {
        eventId: {
            immediate: true,
            handler() {
                this._loadLocations();
            }
        }
    },

    methods: {
        _loadLocations() {
            if (!this.eventId) {
                this.locations = [];
                return;
            }

            Event.Service.getAllEventLocations({
                eventId: this.eventId
            })
                .then(locations => {
                    this.locations = locations;
                })
                .catch(() => {
                    this.locations = [];
                });
        }
    }
};
</script>
